import React from 'react'
import SetNewPasswordForm from './SetNewPasswordForm'

const SetNewPasword = () => {
    return (
        <div className='login min-h-screen 2xl:p-40 2xl:px-96 xl:p-40 flex justify-center items-center'>
            <SetNewPasswordForm/>
        </div>
    )
}

export default SetNewPasword